<div class="container">
  <div class="card">
    <div class="welcome-text">
      <img ngSrc="logo.svg" priority alt="Suburban Supply Logo" class="logo" height="236" width="236" />
      <h1>Welcome to Suburban Supply.</h1>
      <div class="error-wrapper">
        <div class="error flex flex-column gap-2">
          <div class="text-sm flex gap-2 align-items-center">
            <i class="app-icon app-icon-exclamation-triangle"></i>
            <h4 class="m-0">Forbidden</h4>
          </div>
          <p class="text-sm pl-4 pr-4">
            {{
              isAccessDenied
                ? 'You do not have access to this section'
                : 'You do not have the required role to access this resource'
            }}
          </p>
        </div>
      </div>
    </div>
    <app-button [label]="actionLabel" styleClass="login-btn" (click)="login()"></app-button>
  </div>
</div>
